var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoubleArrowCircled = function SvgDoubleArrowCircled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 20.1794C16.9921 20.5048 16.9921 21.0325 16.6666 21.3579L15.3115 22.7131H21.6329C22.0932 22.7131 22.4663 23.0862 22.4663 23.5464C22.4663 24.0067 22.0932 24.3798 21.6329 24.3798H15.3115L16.6666 25.735C16.9921 26.0604 16.9921 26.588 16.6666 26.9135C16.3412 27.2389 15.8136 27.2389 15.4881 26.9135L12.7104 24.1357C12.3849 23.8102 12.3849 23.2826 12.7104 22.9572L15.4881 20.1794C15.8136 19.854 16.3412 19.854 16.6666 20.1794Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8889 13.235C23.5634 12.9095 23.0358 12.9095 22.7104 13.235C22.3849 13.5604 22.3849 14.088 22.7104 14.4135L24.0655 15.7687H17.7441C17.2838 15.7687 16.9107 16.1417 16.9107 16.602C16.9107 17.0622 17.2838 17.4353 17.7441 17.4353H24.0655L22.7104 18.7905C22.3849 19.1159 22.3849 19.6436 22.7104 19.969C23.0358 20.2945 23.5634 20.2945 23.8889 19.969L26.6666 17.1912C26.9921 16.8658 26.9921 16.3382 26.6666 16.0127L23.8889 13.235Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleArrowCircled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DoubleArrowCircled.1ddc985437c0942f0610ada4bba5d14f.svg";